/*!
 * inquiry-chat.js — ライスKING お問い合わせデスク 顧客向けウィジェット/履歴ページ
 *
 * 依存パッケージなし（ES2017程度）。IIFEで1グローバルも汚さない。
 * 読み込み方:
 *   <script src="{{ 'inquiry-chat.js' | asset_url }}" defer
 *           data-endpoint="https://example.com"
 *           data-mode="widget"            (省略時 widget。history 指定で履歴ページ用)
 *           data-customer-id="..."
 *           data-customer-email="..."
 *           data-customer-name="..."></script>
 *
 * data-endpoint が空文字なら同一オリジンにリクエストする（管理画面のウィジェットプレビュー用）。
 * CSS は本ファイル内で <style> を注入する。クラス名は全て "rkq-" プレフィックス。
 * 絵文字は使わない。
 */
(function () {
  'use strict';

  // 二重読み込みガード（テーマ側で誤って複数回 render された場合の保険）
  if (window.__rkqInquiryChatLoaded) return;
  window.__rkqInquiryChatLoaded = true;

  // ===== 1. 起動元 <script> タグの特定 =====
  // defer 付きでも document.currentScript は実行中のこの <script> を指す。
  // 万一 currentScript が取れない環境（一部の非同期挿入パターン等）向けに querySelector フォールバックを用意する。
  var scriptEl = document.currentScript || document.querySelector('script[data-endpoint]');
  var ds = (scriptEl && scriptEl.dataset) || {};

  var ENDPOINT = (ds.endpoint || '').replace(/\/+$/, ''); // 空なら同一オリジン
  // スニペットのプレースホルダ __ENDPOINT__ が置換されていない(=エッジ未配置)ときは、通信せず「準備中」を案内する
  var UNCONFIGURED = /__ENDPOINT__/.test(ENDPOINT);
  var MODE = ds.mode === 'history' ? 'history' : 'widget';
  var CUSTOMER_ID = ds.customerId || '';
  var CUSTOMER_EMAIL = ds.customerEmail || '';
  var CUSTOMER_NAME = ds.customerName || '';

  var BODY_MAX = 4000;

  // ===== 2. localStorage ラッパー（プライベートモード等で使えない場合はメモリにフォールバック） =====
  var memStore = {};
  var storage = (function () {
    var ok = false;
    try {
      var k = '__rkq_test__';
      window.localStorage.setItem(k, '1');
      window.localStorage.removeItem(k);
      ok = true;
    } catch (e) { ok = false; }
    return {
      get: function (key) {
        if (ok) {
          try { return window.localStorage.getItem(key); } catch (e) { return memStore[key] || null; }
        }
        return memStore[key] || null;
      },
      set: function (key, val) {
        if (ok) {
          try { window.localStorage.setItem(key, val); return; } catch (e) { /* fall through */ }
        }
        memStore[key] = val;
      },
      remove: function (key) {
        if (ok) {
          try { window.localStorage.removeItem(key); } catch (e) { /* noop */ }
        }
        delete memStore[key];
      }
    };
  })();

  var TOKEN_KEY = 'rk_inq_token';
  var CONV_KEY = 'rk_inq_conv'; // 現在表示中の会話番号（JSON文字列 {"number":"INQ-00012"}）

  function getToken() { return storage.get(TOKEN_KEY) || ''; }
  function setToken(t) { if (t) storage.set(TOKEN_KEY, t); }
  function getCurrentNumber() {
    try {
      var raw = storage.get(CONV_KEY);
      if (!raw) return '';
      var o = JSON.parse(raw);
      return (o && o.number) || '';
    } catch (e) { return ''; }
  }
  function setCurrentNumber(n) {
    if (n) storage.set(CONV_KEY, JSON.stringify({ number: n }));
    else storage.remove(CONV_KEY);
  }

  // ===== 3. HTMLエスケープ =====
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ===== 4. API 呼び出し =====
  function apiFetch(path, opts) {
    opts = opts || {};
    if (UNCONFIGURED) {
      var uerr = new Error('お問い合わせ窓口は現在準備中です。恐れ入りますが、しばらくしてからお試しください。');
      uerr.status = 0;
      return Promise.reject(uerr);
    }
    var url = ENDPOINT + path;
    var init = {
      method: opts.method || 'GET',
      headers: { 'Content-Type': 'application/json' }
    };
    if (opts.body) init.body = JSON.stringify(opts.body);
    return fetch(url, init).then(function (res) {
      return res.text().then(function (text) {
        var data = null;
        if (text) { try { data = JSON.parse(text); } catch (e) { data = null; } }
        if (!res.ok) {
          var msg = (data && (data.error || data.message)) || ('通信エラー（' + res.status + '）');
          var err = new Error(msg);
          err.status = res.status;
          err.data = data;
          throw err;
        }
        return data || {};
      });
    });
  }

  // レスポンスの包み方が {conversation:{...}} でも会話オブジェクト直返しでも吸収する
  function pickConversation(res) {
    if (!res) return null;
    return res.conversation || res;
  }
  function pickList(res) {
    if (!res) return [];
    if (Array.isArray(res)) return res;
    return res.items || res.conversations || res.list || [];
  }

  // ===== 5. 日時整形 =====
  function formatTime(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    var mm = d.getMonth() + 1, dd = d.getDate();
    var hh = ('0' + d.getHours()).slice(-2), mi = ('0' + d.getMinutes()).slice(-2);
    return mm + '/' + dd + ' ' + hh + ':' + mi;
  }

  // ===== 6. スタイル注入 =====
  function injectStyle() {
    if (document.getElementById('rkq-style')) return;
    var css = ''
      + ':root{}'
      + '.rkq-root{all:initial;}'
      + '.rkq-root *{box-sizing:border-box;font-family:-apple-system,BlinkMacSystemFont,"Hiragino Sans","Yu Gothic UI",Meiryo,sans-serif;}'
      + '.rkq-launcher{position:fixed;right:20px;bottom:20px;width:56px;height:56px;border-radius:50%;'
      + 'background:#4f46e5;color:#fff;border:none;box-shadow:0 4px 14px rgba(17,18,20,.22);cursor:pointer;'
      + 'display:flex;align-items:center;justify-content:center;z-index:2147483000;padding:0;}'
      + '.rkq-launcher:hover{background:#4338ca;}'
      + '.rkq-launcher svg{width:26px;height:26px;}'
      + '.rkq-dot{position:absolute;top:4px;right:4px;width:11px;height:11px;border-radius:50%;background:#dc2626;'
      + 'border:2px solid #fff;}'
      + '.rkq-panel{position:fixed;right:20px;bottom:88px;width:360px;height:560px;max-height:calc(100vh - 110px);'
      + 'background:#ffffff;border:1px solid #e6e8ec;border-radius:12px;box-shadow:0 10px 34px rgba(17,18,20,.18);'
      + 'display:none;flex-direction:column;overflow:hidden;z-index:2147483000;}'
      + '.rkq-panel.rkq-open{display:flex;}'
      + '@media (max-width:480px){'
      + '  .rkq-panel{right:0;left:0;bottom:0;top:0;width:auto;height:auto;max-height:none;border-radius:0;}'
      + '}'
      + '.rkq-head{flex:0 0 auto;display:flex;align-items:center;gap:8px;padding:12px 14px;border-bottom:1px solid #e6e8ec;background:#ffffff;}'
      + '.rkq-head-title{flex:1;min-width:0;font-size:14px;font-weight:700;color:#17181c;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}'
      + '.rkq-head-btn{background:none;border:none;padding:6px;cursor:pointer;color:#7b7f88;border-radius:6px;display:flex;}'
      + '.rkq-head-btn:hover{background:#f7f8fa;color:#17181c;}'
      + '.rkq-head-btn svg{width:18px;height:18px;}'
      + '.rkq-link{background:none;border:none;padding:0;color:#4f46e5;font-size:12px;cursor:pointer;text-decoration:underline;white-space:nowrap;}'
      + '.rkq-body{flex:1 1 auto;min-height:0;overflow-y:auto;padding:12px;background:#f7f8fa;}'
      + '.rkq-foot{flex:0 0 auto;border-top:1px solid #e6e8ec;padding:10px;background:#ffffff;}'
      + '.rkq-greet{font-size:12.5px;color:#3f4249;line-height:1.6;margin:0 0 10px;}'
      + '.rkq-offline{font-size:11.5px;color:#7b7f88;margin:0 0 10px;}'
      + '.rkq-field{margin:0 0 10px;}'
      + '.rkq-field label{display:block;font-size:11.5px;color:#7b7f88;margin:0 0 4px;}'
      + '.rkq-field input,.rkq-field textarea{width:100%;border:1px solid #d5d8de;border-radius:8px;padding:8px 10px;'
      + 'font-size:13px;color:#17181c;background:#fff;resize:vertical;}'
      + '.rkq-field input:focus,.rkq-field textarea:focus{outline:none;border-color:#4f46e5;}'
      + '.rkq-field textarea{min-height:90px;line-height:1.5;}'
      + '.rkq-btn{display:inline-flex;align-items:center;justify-content:center;gap:6px;background:#4f46e5;color:#fff;'
      + 'border:none;border-radius:8px;padding:9px 14px;font-size:13px;font-weight:600;cursor:pointer;width:100%;}'
      + '.rkq-btn:hover{background:#4338ca;}'
      + '.rkq-btn:disabled{background:#c7c9d6;cursor:default;}'
      + '.rkq-btn-ghost{background:#fff;color:#4f46e5;border:1px solid #4f46e5;}'
      + '.rkq-btn-ghost:hover{background:#eef0fe;}'
      + '.rkq-err{background:#fdecec;color:#b91c1c;border:1px solid #f6c8c8;border-radius:8px;padding:8px 10px;'
      + 'font-size:12px;margin:0 0 10px;}'
      + '.rkq-msg-row{display:flex;margin:0 0 10px;}'
      + '.rkq-msg-row.rkq-me{justify-content:flex-end;}'
      // 吹き出しと日時をまとめる内側の箱。列方向 flex にして、自分(顧客)の発言は右寄せ・相手は左寄せに揃える
      + '.rkq-msg-row>div{display:flex;flex-direction:column;max-width:78%;}'
      + '.rkq-me>div{align-items:flex-end;}'
      + '.rkq-them>div{align-items:flex-start;}'
      + '.rkq-bubble{max-width:100%;padding:8px 11px;border-radius:12px;font-size:13px;line-height:1.55;white-space:pre-wrap;word-break:break-word;}'
      + '.rkq-me .rkq-bubble{background:#4f46e5;color:#fff;border-bottom-right-radius:3px;}'
      + '.rkq-them .rkq-bubble{background:#fff;color:#17181c;border:1px solid #e6e8ec;border-bottom-left-radius:3px;}'
      + '.rkq-sys{display:flex;justify-content:center;margin:8px 0;}'
      + '.rkq-sys span{font-size:11px;color:#7b7f88;background:#eceef2;border-radius:20px;padding:3px 10px;}'
      + '.rkq-meta{font-size:10.5px;color:#7b7f88;margin-top:3px;}'
      + '.rkq-me .rkq-meta{text-align:right;}'
      + '.rkq-list-item{display:flex;flex-direction:column;gap:2px;padding:10px 12px;border:1px solid #e6e8ec;'
      + 'border-radius:8px;background:#fff;margin:0 0 8px;cursor:pointer;}'
      + '.rkq-list-item:hover{border-color:#4f46e5;}'
      + '.rkq-list-top{display:flex;justify-content:space-between;gap:8px;}'
      + '.rkq-list-num{font-size:11px;color:#7b7f88;}'
      + '.rkq-list-subj{font-size:13px;color:#17181c;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}'
      + '.rkq-list-sub{display:flex;justify-content:space-between;font-size:11px;color:#7b7f88;margin-top:2px;}'
      + '.rkq-badge{font-size:10.5px;padding:1px 7px;border-radius:20px;background:#eef0fe;color:#4f46e5;white-space:nowrap;}'
      + '.rkq-badge-closed{background:#eceef2;color:#7b7f88;}'
      + '.rkq-dot-inline{width:7px;height:7px;border-radius:50%;background:#dc2626;display:inline-block;margin-right:4px;}'
      + '.rkq-empty{font-size:12.5px;color:#7b7f88;text-align:center;padding:30px 10px;}'
      + '.rkq-row2{display:flex;gap:8px;}'
      + '.rkq-row2 .rkq-btn{flex:1;}'
      + '.rkq-input-row{display:flex;gap:8px;align-items:flex-end;}'
      + '.rkq-input-row textarea{flex:1;min-height:40px;max-height:120px;}'
      + '.rkq-send{flex:0 0 auto;width:40px;height:40px;border-radius:8px;background:#4f46e5;color:#fff;border:none;'
      + 'display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;}'
      + '.rkq-send:hover{background:#4338ca;}'
      + '.rkq-send:disabled{background:#c7c9d6;cursor:default;}'
      + '.rkq-send svg{width:18px;height:18px;}'
      + '.rkq-hint{font-size:10.5px;color:#7b7f88;margin-top:6px;}'
      + '.rkq-demo{font-size:10.5px;color:#7b7f88;margin-top:8px;}'
      + '.rkq-history-wrap{max-width:520px;}'
      + '.rkq-code-input{letter-spacing:4px;text-align:center;font-size:18px;}';
    var styleEl = document.createElement('style');
    styleEl.id = 'rkq-style';
    styleEl.textContent = css;
    document.head.appendChild(styleEl);
  }

  // ===== 7. インラインSVGアイコン（lucide風・ストローク） =====
  function svgIcon(pathD, viewBox) {
    return '<svg viewBox="' + (viewBox || '0 0 24 24') + '" fill="none" stroke="currentColor" '
      + 'stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + pathD + '</svg>';
  }
  var ICON_CHAT = svgIcon('<path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"/>');
  var ICON_CLOSE = svgIcon('<path d="M18 6 6 18"/><path d="M6 6l12 12"/>');
  var ICON_SEND = svgIcon('<path d="m22 2-7 20-4-9-9-4Z"/><path d="M22 2 11 13"/>');
  var ICON_BACK = svgIcon('<path d="m15 18-6-6 6-6"/>');

  // =====================================================================
  // 8. widget モード
  // =====================================================================
  function initWidget() {
    injectStyle();

    var root = document.createElement('div');
    root.className = 'rkq-root';

    var launcher = document.createElement('button');
    launcher.type = 'button';
    launcher.className = 'rkq-launcher';
    launcher.setAttribute('aria-label', 'お問い合わせを開く');
    launcher.innerHTML = ICON_CHAT + '<span class="rkq-dot" style="display:none;" id="rkq-unread-dot"></span>';

    var panel = document.createElement('div');
    panel.className = 'rkq-panel';
    panel.innerHTML =
      '<div class="rkq-head">'
      + '<button type="button" class="rkq-head-btn" id="rkq-back" style="display:none;">' + ICON_BACK + '</button>'
      + '<div class="rkq-head-title" id="rkq-title">お問い合わせ</div>'
      + '<button type="button" class="rkq-link" id="rkq-history-link">過去のお問い合わせ</button>'
      + '<button type="button" class="rkq-head-btn" id="rkq-close">' + ICON_CLOSE + '</button>'
      + '</div>'
      + '<div class="rkq-body" id="rkq-body"></div>'
      + '<div class="rkq-foot" id="rkq-foot"></div>';

    root.appendChild(launcher);
    root.appendChild(panel);
    document.body.appendChild(root);

    var bodyEl = panel.querySelector('#rkq-body');
    var footEl = panel.querySelector('#rkq-foot');
    var titleEl = panel.querySelector('#rkq-title');
    var backBtn = panel.querySelector('#rkq-back');
    var closeBtn = panel.querySelector('#rkq-close');
    var historyLink = panel.querySelector('#rkq-history-link');
    var unreadDot = launcher.querySelector('#rkq-unread-dot');

    var state = {
      open: false,
      screen: 'loading', // loading | form | thread | list
      config: null,
      conversation: null, // 現在表示中の会話（顧客/スタッフメッセージのみ）
      sending: false
    };

    function setTitle(text) { titleEl.textContent = text || 'お問い合わせ'; }

    function showError(container, message) {
      var el = document.createElement('div');
      el.className = 'rkq-err';
      el.textContent = message;
      container.insertBefore(el, container.firstChild);
    }

    // ---- 画面: 初回問い合わせフォーム ----
    function renderForm() {
      state.screen = 'form';
      backBtn.style.display = getCurrentNumber() ? 'flex' : 'none';
      setTitle((state.config && state.config.widget_title) || 'お問い合わせ');
      bodyEl.innerHTML =
        (state.config && state.config.widget_greeting
          ? '<p class="rkq-greet">' + esc(state.config.widget_greeting) + '</p>'
          : '<p class="rkq-greet">ご質問・ご要望をお気軽にお送りください。</p>')
        + (state.config && state.config.widget_offline_note
          ? '<p class="rkq-offline">' + esc(state.config.widget_offline_note) + '</p>' : '');
      footEl.innerHTML =
        '<div class="rkq-field"><label>お名前（任意）</label><input type="text" id="rkq-f-name" maxlength="80"></div>'
        + '<div class="rkq-field"><label>メールアドレス（任意）</label><input type="email" id="rkq-f-email" maxlength="200"></div>'
        + '<div class="rkq-field"><label>お問い合わせ内容</label><textarea id="rkq-f-body" maxlength="' + BODY_MAX + '" placeholder="内容をご記入ください"></textarea></div>'
        + '<button type="button" class="rkq-btn" id="rkq-f-submit">送信する</button>';

      var nameInput = footEl.querySelector('#rkq-f-name');
      var emailInput = footEl.querySelector('#rkq-f-email');
      var bodyInput = footEl.querySelector('#rkq-f-body');
      if (CUSTOMER_NAME) nameInput.value = CUSTOMER_NAME;
      if (CUSTOMER_EMAIL) emailInput.value = CUSTOMER_EMAIL;

      var submitBtn = footEl.querySelector('#rkq-f-submit');
      submitBtn.addEventListener('click', function () { submitFirstMessage(nameInput, emailInput, bodyInput, submitBtn); });
      bodyInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
          e.preventDefault();
          submitFirstMessage(nameInput, emailInput, bodyInput, submitBtn);
        }
      });
    }

    function submitFirstMessage(nameInput, emailInput, bodyInput, submitBtn) {
      if (state.sending) return;
      var body = (bodyInput.value || '').trim();
      if (!body) { showError(footEl, 'お問い合わせ内容を入力してください。'); return; }
      if (body.length > BODY_MAX) { showError(footEl, '本文は' + BODY_MAX + '文字以内でお願いします。'); return; }
      state.sending = true;
      submitBtn.disabled = true;
      submitBtn.textContent = '送信中...';
      apiFetch('/api/public/conversations', {
        method: 'POST',
        body: {
          token: getToken() || undefined,
          name: nameInput.value || undefined,
          email: emailInput.value || undefined,
          body: body,
          customer_id: CUSTOMER_ID || undefined,
          customer_email: CUSTOMER_EMAIL || undefined,
          page_url: window.location.href
        }
      }).then(function (res) {
        if (res.token) setToken(res.token);
        var conv = pickConversation(res);
        if (conv && conv.number) setCurrentNumber(conv.number);
        state.conversation = conv;
        state.sending = false;
        renderThread();
        schedulePoll();
      }).catch(function (e) {
        state.sending = false;
        submitBtn.disabled = false;
        submitBtn.textContent = '送信する';
        showError(footEl, e.message || '送信できませんでした。時間をおいて再度お試しください。');
      });
    }

    // ---- 画面: スレッド ----
    function renderThread() {
      state.screen = 'thread';
      backBtn.style.display = 'flex';
      var conv = state.conversation || {};
      setTitle(conv.subject || (state.config && state.config.widget_title) || 'お問い合わせ');

      var msgs = (conv.messages || []).filter(function (m) { return m.dir === 'customer' || m.dir === 'staff'; });
      var html = '';
      if (!msgs.length) {
        html = '<p class="rkq-empty">メッセージはまだありません。</p>';
      } else {
        msgs.forEach(function (m) {
          if (m.dir === 'system') {
            html += '<div class="rkq-sys"><span>' + esc(m.body) + '</span></div>';
            return;
          }
          var me = m.dir === 'customer';
          html += '<div class="rkq-msg-row ' + (me ? 'rkq-me' : 'rkq-them') + '">'
            + '<div><div class="rkq-bubble">' + esc(m.body) + '</div>'
            + '<div class="rkq-meta">' + esc(me ? '' : (m.author || 'スタッフ')) + ' ' + esc(formatTime(m.at)) + '</div>'
            + '</div></div>';
        });
      }
      bodyEl.innerHTML = html;
      bodyEl.scrollTop = bodyEl.scrollHeight;

      var closed = conv.status === 'closed';
      var footHtml = '';
      if (closed) {
        footHtml += '<button type="button" class="rkq-btn rkq-btn-ghost" id="rkq-newconv" style="margin-bottom:8px;">新しいお問い合わせを始める</button>';
      }
      footHtml +=
        '<div class="rkq-input-row">'
        + '<textarea id="rkq-t-body" maxlength="' + BODY_MAX + '" placeholder="' + (closed ? 'この問い合わせは完了しています' : 'メッセージを入力（Cmd/Ctrl+Enterで送信）') + '"' + (closed ? ' disabled' : '') + '></textarea>'
        + '<button type="button" class="rkq-send" id="rkq-t-send"' + (closed ? ' disabled' : '') + '>' + ICON_SEND + '</button>'
        + '</div>';
      footEl.innerHTML = footHtml;

      var newBtn = footEl.querySelector('#rkq-newconv');
      if (newBtn) {
        newBtn.addEventListener('click', function () {
          setCurrentNumber('');
          state.conversation = null;
          renderForm();
        });
      }

      var tBody = footEl.querySelector('#rkq-t-body');
      var tSend = footEl.querySelector('#rkq-t-send');
      if (!closed) {
        tSend.addEventListener('click', function () { sendReply(tBody, tSend); });
        tBody.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
            e.preventDefault();
            sendReply(tBody, tSend);
          }
        });
      }
    }

    function sendReply(tBody, tSend) {
      if (state.sending) return;
      var body = (tBody.value || '').trim();
      if (!body) return;
      if (body.length > BODY_MAX) { showError(bodyEl, '本文は' + BODY_MAX + '文字以内でお願いします。'); return; }
      state.sending = true;
      tSend.disabled = true;
      var number = state.conversation.number;
      apiFetch('/api/public/conversations/' + encodeURIComponent(number) + '/messages', {
        method: 'POST',
        body: { token: getToken(), body: body }
      }).then(function (res) {
        state.sending = false;
        var conv = pickConversation(res);
        if (conv) {
          state.conversation = conv;
        } else if (state.conversation) {
          // 応答に会話全体が含まれない実装向けのフォールバック：手元で1件追記して見た目だけ更新
          state.conversation.messages = (state.conversation.messages || []).concat([{
            id: 'local-' + Date.now(), dir: 'customer', body: body, author: '', at: new Date().toISOString(), via: 'widget'
          }]);
          state.conversation.status = 'new';
        }
        tBody.value = '';
        renderThread();
      }).catch(function (e) {
        state.sending = false;
        tSend.disabled = false;
        showError(bodyEl, e.message || '送信できませんでした。');
      });
    }

    // ---- 画面: 会話一覧（過去のお問い合わせ） ----
    function renderList() {
      state.screen = 'list';
      backBtn.style.display = 'flex';
      setTitle('過去のお問い合わせ');
      bodyEl.innerHTML = '<p class="rkq-empty">読み込み中...</p>';
      footEl.innerHTML = '<button type="button" class="rkq-btn rkq-btn-ghost" id="rkq-list-newconv">新しいお問い合わせを始める</button>';
      footEl.querySelector('#rkq-list-newconv').addEventListener('click', function () {
        setCurrentNumber('');
        state.conversation = null;
        renderForm();
      });

      var token = getToken();
      if (!token) {
        bodyEl.innerHTML = '<p class="rkq-empty">まだお問い合わせの記録がありません。</p>';
        return;
      }
      apiFetch('/api/public/conversations?token=' + encodeURIComponent(token)).then(function (res) {
        var items = pickList(res);
        if (!items.length) {
          bodyEl.innerHTML = '<p class="rkq-empty">まだお問い合わせの記録がありません。</p>';
          return;
        }
        var html = '';
        items.forEach(function (it) {
          var closed = it.status === 'closed';
          html += '<div class="rkq-list-item" data-number="' + esc(it.number) + '">'
            + '<div class="rkq-list-top">'
            + '<span class="rkq-list-subj">' + (it.unread_for_customer ? '<span class="rkq-dot-inline"></span>' : '') + esc(it.subject || '（件名なし）') + '</span>'
            + '<span class="rkq-badge ' + (closed ? 'rkq-badge-closed' : '') + '">' + esc(statusLabel(it.status)) + '</span>'
            + '</div>'
            + '<div class="rkq-list-sub"><span class="rkq-list-num">' + esc(it.number) + '</span><span>' + esc(formatTime(it.last_message_at)) + '</span></div>'
            + '</div>';
        });
        bodyEl.innerHTML = html;
        Array.prototype.forEach.call(bodyEl.querySelectorAll('.rkq-list-item'), function (el) {
          el.addEventListener('click', function () {
            var number = el.getAttribute('data-number');
            setCurrentNumber(number);
            openConversation(number);
          });
        });
      }).catch(function (e) {
        if (e.status === 403) storage.remove(TOKEN_KEY);
        bodyEl.innerHTML = '';
        showError(bodyEl, e.message || '一覧を取得できませんでした。');
      });
    }

    function statusLabel(s) {
      if (s === 'new') return '未対応';
      if (s === 'in_progress') return '対応中';
      if (s === 'closed') return '完了';
      return s || '';
    }

    function openConversation(number) {
      bodyEl.innerHTML = '<p class="rkq-empty">読み込み中...</p>';
      footEl.innerHTML = '';
      apiFetch('/api/public/conversations/' + encodeURIComponent(number) + '?token=' + encodeURIComponent(getToken()))
        .then(function (res) {
          state.conversation = pickConversation(res);
          renderThread();
        }).catch(function (e) {
          // 404/403 はローカルに残った古い会話番号が無効になったケース（別端末・データ初期化後 等）。
          // エラーで行き止まりにせず、安全な状態（一覧 or 新規フォーム）まで自動で戻す。
          if (e.status === 403 || e.status === 404) {
            setCurrentNumber('');
            if (getToken()) { renderList(); } else { renderForm(); }
            return;
          }
          bodyEl.innerHTML = '';
          showError(bodyEl, e.message || '会話を取得できませんでした。');
        });
    }

    // ---- ヘッダー操作 ----
    closeBtn.addEventListener('click', function () { setOpen(false); });
    historyLink.addEventListener('click', function () { renderList(); });
    backBtn.addEventListener('click', function () {
      if (state.screen === 'list' || state.screen === 'form') {
        var num = getCurrentNumber();
        if (num && state.conversation) { renderThread(); return; }
        if (num) { openConversation(num); return; }
      }
      renderForm();
    });

    function setOpen(open) {
      state.open = open;
      panel.classList.toggle('rkq-open', open);
      if (open) {
        unreadDot.style.display = 'none'; // 開いたら一旦既読扱いの表示にする（楽観的更新）
        enterPanel();
      }
      schedulePoll();
    }
    launcher.addEventListener('click', function () { setOpen(!state.open); });

    function enterPanel() {
      var num = getCurrentNumber();
      if (num) {
        openConversation(num);
      } else {
        renderForm();
      }
    }

    // ---- 初期化: 設定取得 ----
    apiFetch('/api/public/config').then(function (cfg) {
      state.config = cfg || {};
      setTitle(state.config.widget_title);
      if (state.screen === 'loading') {
        var num = getCurrentNumber();
        if (num) { openConversation(num); } else { renderForm(); }
      }
    }).catch(function () {
      if (state.screen === 'loading') {
        var num = getCurrentNumber();
        if (num) { openConversation(num); } else { renderForm(); }
      }
    });

    // ---- ポーリング ----
    // 開いている間: 8秒ごとに現在のスレッドを差分取得。閉じている間: 30秒ごとに未読チェックのみ。
    // タイマーは1本だけ保持し、都度 clearTimeout してから張り直す（多重化防止）。
    var pollTimer = null;
    function schedulePoll() {
      clearTimeout(pollTimer);
      var delay = state.open ? 8000 : 30000;
      pollTimer = setTimeout(function () {
        poll().then(schedulePoll).catch(schedulePoll);
      }, delay);
    }

    function poll() {
      var token = getToken();
      if (!token) return Promise.resolve();
      if (state.open && state.screen === 'thread' && state.conversation && state.conversation.number) {
        var since = lastMessageAt(state.conversation);
        return apiFetch('/api/public/conversations/' + encodeURIComponent(state.conversation.number)
          + '?token=' + encodeURIComponent(token) + (since ? '&since=' + encodeURIComponent(since) : ''))
          .then(function (res) {
            var conv = pickConversation(res);
            if (conv) { mergeConversation(conv); if (state.screen === 'thread') renderThread(); }
          }).catch(function () { /* ポーリング失敗は静かに無視し次回再試行 */ });
      }
      if (!state.open) {
        return apiFetch('/api/public/conversations?token=' + encodeURIComponent(token)).then(function (res) {
          var items = pickList(res);
          var unread = items.some(function (it) { return it.unread_for_customer; });
          unreadDot.style.display = unread ? 'block' : 'none';
        }).catch(function () { /* 未読チェック失敗は無視 */ });
      }
      return Promise.resolve();
    }

    function lastMessageAt(conv) {
      var msgs = (conv.messages || []).filter(function (m) { return m.dir === 'customer' || m.dir === 'staff'; });
      if (!msgs.length) return '';
      return msgs[msgs.length - 1].at || '';
    }

    function mergeConversation(newConv) {
      if (!state.conversation || state.conversation.number !== newConv.number) {
        state.conversation = newConv;
        return;
      }
      // since 指定分だけ返る想定 → 既存メッセージに id 重複なしで追記する
      var existing = state.conversation.messages || [];
      var incoming = newConv.messages || [];
      var seen = {};
      existing.forEach(function (m) { seen[m.id] = true; });
      incoming.forEach(function (m) { if (!seen[m.id]) { existing.push(m); seen[m.id] = true; } });
      state.conversation = Object.assign({}, newConv, { messages: existing });
    }

    schedulePoll();
  }

  // =====================================================================
  // 9. history モード（お問い合わせ履歴ページ埋め込み用）
  // =====================================================================
  function initHistory() {
    var container = document.getElementById('rkq-history');
    if (!container) return; // 埋め込み先が無ければ何もしない
    injectStyle();
    container.classList.add('rkq-root');

    var wrap = document.createElement('div');
    wrap.className = 'rkq-history-wrap';
    container.appendChild(wrap);

    var state = { screen: 'loading', email: '', conversation: null };

    function render(html) { wrap.innerHTML = html; }
    function showError(el, message) {
      var e = document.createElement('div');
      e.className = 'rkq-err';
      e.textContent = message;
      el.insertBefore(e, el.firstChild);
    }
    function statusLabel(s) {
      if (s === 'new') return '未対応';
      if (s === 'in_progress') return '対応中';
      if (s === 'closed') return '完了';
      return s || '';
    }

    function start() {
      var token = getToken();
      if (token) { renderList(); } else { renderVerifyRequest(); }
    }

    // ---- トークンがある場合: 会話一覧 ----
    function renderList() {
      render('<p class="rkq-empty">読み込み中...</p>');
      apiFetch('/api/public/conversations?token=' + encodeURIComponent(getToken())).then(function (res) {
        var items = pickList(res);
        if (!items.length) {
          render('<p class="rkq-empty">お問い合わせの記録がありません。</p>');
          return;
        }
        var html = '';
        items.forEach(function (it) {
          var closed = it.status === 'closed';
          html += '<div class="rkq-list-item" data-number="' + esc(it.number) + '">'
            + '<div class="rkq-list-top">'
            + '<span class="rkq-list-subj">' + esc(it.subject || '（件名なし）') + '</span>'
            + '<span class="rkq-badge ' + (closed ? 'rkq-badge-closed' : '') + '">' + esc(statusLabel(it.status)) + '</span>'
            + '</div>'
            + '<div class="rkq-list-sub"><span class="rkq-list-num">' + esc(it.number) + '</span><span>' + esc(formatTime(it.last_message_at)) + '</span></div>'
            + '</div>';
        });
        render(html);
        Array.prototype.forEach.call(wrap.querySelectorAll('.rkq-list-item'), function (el) {
          el.addEventListener('click', function () { openConversation(el.getAttribute('data-number')); });
        });
      }).catch(function (e) {
        // トークンが無効（期限切れ・別環境のデータ等）なら行き止まりにせず確認フォームへ戻す
        if (e.status === 403) {
          storage.remove(TOKEN_KEY);
          renderVerifyRequest();
          return;
        }
        render('');
        showError(wrap, e.message || '一覧を取得できませんでした。');
      });
    }

    function openConversation(number) {
      render('<p class="rkq-empty">読み込み中...</p>');
      apiFetch('/api/public/conversations/' + encodeURIComponent(number) + '?token=' + encodeURIComponent(getToken()))
        .then(function (res) {
          state.conversation = pickConversation(res);
          renderThread();
        }).catch(function (e) {
          render('<button type="button" class="rkq-link" id="rkq-h-back2">&larr; 一覧に戻る</button>');
          showError(wrap, e.message || '会話を取得できませんでした。');
          var back = wrap.querySelector('#rkq-h-back2');
          if (back) back.addEventListener('click', renderList);
        });
    }

    function renderThread() {
      var conv = state.conversation || {};
      var msgs = (conv.messages || []).filter(function (m) { return m.dir === 'customer' || m.dir === 'staff'; });
      var html = '<button type="button" class="rkq-link" id="rkq-h-back" style="margin-bottom:12px;">&larr; 一覧に戻る</button>'
        + '<div style="border:1px solid #e6e8ec;border-radius:10px;padding:14px;background:#f7f8fa;">';
      if (!msgs.length) {
        html += '<p class="rkq-empty">メッセージはまだありません。</p>';
      } else {
        msgs.forEach(function (m) {
          var me = m.dir === 'customer';
          html += '<div class="rkq-msg-row ' + (me ? 'rkq-me' : 'rkq-them') + '">'
            + '<div><div class="rkq-bubble">' + esc(m.body) + '</div>'
            + '<div class="rkq-meta">' + esc(me ? '' : (m.author || 'スタッフ')) + ' ' + esc(formatTime(m.at)) + '</div>'
            + '</div></div>';
        });
      }
      html += '</div>';
      if (conv.status !== 'closed') {
        html += '<div class="rkq-field" style="margin-top:12px;"><textarea id="rkq-h-body" maxlength="' + BODY_MAX + '" placeholder="メッセージを入力（Cmd/Ctrl+Enterで送信）"></textarea></div>'
          + '<button type="button" class="rkq-btn" id="rkq-h-send" style="width:auto;padding:9px 20px;">送信する</button>';
      }
      render(html);
      wrap.querySelector('#rkq-h-back').addEventListener('click', renderList);
      var sendBtn = wrap.querySelector('#rkq-h-send');
      if (sendBtn) {
        var bodyInput = wrap.querySelector('#rkq-h-body');
        var send = function () {
          var body = (bodyInput.value || '').trim();
          if (!body) return;
          sendBtn.disabled = true;
          apiFetch('/api/public/conversations/' + encodeURIComponent(conv.number) + '/messages', {
            method: 'POST', body: { token: getToken(), body: body }
          }).then(function (res) {
            var c = pickConversation(res);
            if (c) state.conversation = c;
            openConversation(conv.number);
          }).catch(function (e) {
            sendBtn.disabled = false;
            showError(wrap, e.message || '送信できませんでした。');
          });
        };
        sendBtn.addEventListener('click', send);
        bodyInput.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) { e.preventDefault(); send(); }
        });
      }
    }

    // ---- トークンが無い場合: メールで確認 ----
    function renderVerifyRequest() {
      render(
        '<p class="rkq-greet">メールアドレスでお問い合わせ履歴を確認できます。</p>'
        + '<div class="rkq-field"><label>メールアドレス</label><input type="email" id="rkq-v-email" maxlength="200"></div>'
        + '<button type="button" class="rkq-btn" id="rkq-v-request" style="width:auto;padding:9px 20px;">確認コードを送る</button>'
      );
      var emailInput = wrap.querySelector('#rkq-v-email');
      if (CUSTOMER_EMAIL) emailInput.value = CUSTOMER_EMAIL;
      var btn = wrap.querySelector('#rkq-v-request');
      btn.addEventListener('click', function () {
        var email = (emailInput.value || '').trim();
        if (!email) { showError(wrap, 'メールアドレスを入力してください。'); return; }
        btn.disabled = true;
        apiFetch('/api/public/verify/request', { method: 'POST', body: { email: email } }).then(function (res) {
          state.email = email;
          renderVerifyConfirm(res && res.demo_code);
        }).catch(function (e) {
          btn.disabled = false;
          showError(wrap, e.message || '送信できませんでした。');
        });
      });
    }

    function renderVerifyConfirm(demoCode) {
      render(
        '<p class="rkq-greet">' + esc(state.email) + ' 宛に確認コードを送信しました。届いた6桁のコードを入力してください。</p>'
        + '<div class="rkq-field"><label>確認コード</label><input type="text" id="rkq-v-code" class="rkq-code-input" maxlength="6" inputmode="numeric"></div>'
        + '<button type="button" class="rkq-btn" id="rkq-v-confirm" style="width:auto;padding:9px 20px;">確認する</button>'
        + (demoCode ? '<p class="rkq-demo">（デモ表示用コード: ' + esc(demoCode) + '）</p>' : '')
      );
      var codeInput = wrap.querySelector('#rkq-v-code');
      var btn = wrap.querySelector('#rkq-v-confirm');
      btn.addEventListener('click', function () {
        var code = (codeInput.value || '').trim();
        if (!code) { showError(wrap, 'コードを入力してください。'); return; }
        btn.disabled = true;
        apiFetch('/api/public/verify/confirm', { method: 'POST', body: { email: state.email, code: code } }).then(function (res) {
          if (res.token) setToken(res.token);
          renderList();
        }).catch(function (e) {
          btn.disabled = false;
          showError(wrap, e.message || 'コードが正しくありません。');
        });
      });
    }

    start();
  }

  // ===== 起動 =====
  function boot() {
    if (MODE === 'history') initHistory();
    else initWidget();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();